import React, { Component } from 'react'
import { MailIcon } from '../svgIcons'
import { BasicLazyParams } from '../../utile'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { Button } from 'primereact/button'
import { Dialog } from 'primereact/dialog'
import { RadioButton } from 'primereact/radiobutton'
import ClassetStudentSearch from '../../classetComponents/classetStudentSearch'
import ClassetDropdown from '../../classetComponents/classetDropDown'
import Service from '../../services'
import { baseUrlAdmin } from '../../store/apiConstants'
import ClassetInputText from '../../classetComponents/classetInputText'
import ClassetTextArea from '../../classetComponents/classetTextArea'
import ClassetCalendar from '../../classetComponents/classetCalender'
import { Toast } from 'primereact/toast'
import LoadingComponent from '../loadingComponent'
import { debounce } from 'lodash';
import BranchToSectionDD from '../BaseDropdownComponents/BranchToSectionDD'
import ClassetStudentSearchFilter from '../Search/ClassetStudentSearchFilter'
import { paymentModes } from '../../constants'
const searchTypeOptions = [
    { label: "Student Name", value: "studentName" },
    { label: "Enrollment Number", value: "enrollmentNumber" }
]

const feeConcessionTypesOptions = [
    { value: 'merit', label: 'Merit-based' },
    { value: 'sports', label: 'Sports' },
    { value: 'financial', label: 'Financial Aid' },
    { value: 'alumni', label: 'Alumni' },
    { value: 'staff', label: 'Staff Child' }
];



export class FeeRefund extends Component {
    constructor(props) {
        super(props);

        this.state = {
            lazyParams: BasicLazyParams,
            searchType: 1,
            searchInput: "",
            studentsData: [],
            openConcessionDialog: false,
            raiseData: [],
            RefundfeeData: [],
            studentId: '',
            searchLevel: 1,
            feeConcessionTypesOptions: feeConcessionTypesOptions,
            searchType: searchTypeOptions[0].value,
            totalRefundAmt: 0,
            refundRemarks: '',
            showParentDetailsDialog: false,
            paymentType: '',
            chequeIssuedTo: '',
            chequeNo: '',
            chequeDate: null,
            bankName: '',
            bankBranchName: '',
            // New fields for Online payment
            bankAccountHolderName: '',
            accountNumber: '',
            ifscCode: '',
            bankNameAndBranch: '',
            // New field for QR Code payment
            upiId: ''
        };
        this.debouncedApiCall = debounce(this.getStudentData, 500)
        this.service = new Service();
    }


    setDropdownValues = (dropdownsData) => {
        this.setState({
            dropdownsData,
            studentId: ""
        }, () => { this.getStudents(); this.getStudentData() })
    }

    setDropdownValues = (dropdownsData) => {
        console.log(dropdownsData, "dropdownsData");

        this.setState({
            dropdownsData,
            data: [],
            studentId: dropdownsData?.studentIds?.[0] || '' // Set first studentId if exists
        }, () => {
            if (dropdownsData?.studentIds?.length > 0) {
                // If studentIds exists, call getData directly
                // this.getData();
                this.getStudentData()
            } else {
                this.getStudents(); this.getStudentData()
            }
        });
    }


    getStudentData = () => {

        this.setState({ isLoading: true })
        let academicYear = localStorage.getItem('userAcademicYear')
        let { lazyParams, dropdownsData, searchType, searchValue, studentId } = this.state;
        const { branchId, boardId, classId, sectionId } = dropdownsData
        let url = `${baseUrlAdmin}/concession/get-students?limit=${lazyParams.rows}&page=${lazyParams.page + 1}&search=`

        let username = searchType === 'studentName' ? searchValue : ""
        let enrollmentNo = searchType === 'enrollmentNumber' ? searchValue : ""
        let status = searchType === 'status' ? searchValue : ""

        let payload = {
            branchId,
            boardId,
            classId,
            sectionId,
            studentId,
            academicYear,
            username,
            enrollmentNo,
            status
        }
        if ((branchId && boardId && classId && sectionId) || studentId || username || enrollmentNo || status) {
            this.service.post(url, payload, true).then(data => {

                if (data?.status) {
                    this.setState({
                        studentsData: data?.res?.data,
                        totalRecords: data?.res?.totalRecords,
                        isLoading: false,
                    })

                } else {
                    this.setState({ isLoading: false })
                    this.toast.show({ severity: 'error', summary: 'Some error occurred', detail: data.errMessage, life: 3000 });
                }

            }).catch(error => {
                this.setState({ isLoading: false })
                this.toast.show({
                    severity: 'error',
                    summary: 'Network error',
                    detail: 'An error occurred while processing your request.',
                    life: 3000
                });

            })
        } else {
            this.setState({ isLoading: false });
        }
    }

    getStudents = () => {
        let academicYear = localStorage.getItem('userAcademicYear')
        // let { lazyParams } = this.state;
        this.setState({ isLoading: true })
        let url = `${baseUrlAdmin}/fine/student?status=Active`; // Add status filter
        let payload = {
            "branchId": this.state.dropdownsData?.branchId,
            "boardId": this.state.dropdownsData?.boardId,
            "classId": this.state.dropdownsData?.classId,
            "sectionId": this.state.dropdownsData?.sectionId,
            "academicYear": academicYear
        }
        if (payload?.sectionId) {
            this.service.post(url, payload, true).then(data => {
                // console.log(data, "datastudent")
                const studentsData = data?.res?.data.map(each => {
                    return {
                        label: each?.name,
                        value: each?.user_id
                    }
                })

                if (data?.status) {
                    this.setState({
                        students: studentsData,
                        isLoading: false
                    })

                } else {
                    this.setState({ isLoading: false })
                    this.toast.show({ severity: 'error', summary: 'Some error occurred', detail: data.errMessage, life: 3000 });
                }

            }).catch(error => {
                this.setState({ isLoading: false })

            })
        } else {
            this.setState({ isLoading: false });
        }
    }

    getRaiseConcessionsData = () => {
        this.setState({ isLoading: true })
        let academicYear = localStorage.getItem('userAcademicYear')
        let { lazyParams } = this.state;
        let url = `${baseUrlAdmin}/concession/get-feetype-terms/${this.state?.studentInfo?.user_id}?academicYear=${academicYear}`

        this.service.get(url, true).then(data => {
            const total = data?.res?.data.reduce((accumulator, each) => {
                if (each.concession !== undefined) {
                    accumulator += Number(each.concession);
                }
                return accumulator;
            }, 0);

            if (data?.status) {
                this.setState({
                    raiseData: data?.res?.data,
                    isLoading: false,
                    totalRecords: data?.res?.data?.length,
                    totalConcessionRaised: total
                })

            } else {
                this.setState({ isLoading: false })
                this.toast.show({ severity: 'error', summary: 'Some error occurred', detail: data.errMessage, life: 3000 });
            }

        }).catch(error => {
            this.setState({ isLoading: false })

        })
    }

    getFeeTypesData = () => {
        this.setState({ isLoading: true })
        let academicYear = localStorage.getItem('userAcademicYear')
        let { lazyParams } = this.state;
        let url = `${baseUrlAdmin}/fee-refund/fee-types`
        let payload = {
            user_id: this.state?.studentInfo?.user_id,
            academicYear: academicYear
        }
        this.service.post(url, payload, true).then(data => {

            /* const total = data?.res?.data.reduce((accumulator, each) => {
                if (each.concession !== undefined) {
                    accumulator += Number(each.concession);
                }
                return accumulator;
            }, 0); */

            if (data?.status) {
                this.setState({
                    RefundfeeData: data?.res?.data,
                    isLoading: false,
                    totalRecords: data?.res?.data?.length,
                    totalRefundAmt: data?.res?.totalRefundAmt
                })

            } else {
                this.setState({ isLoading: false })
                this.toast.show({ severity: 'error', summary: 'Some error occurred', detail: data.errMessage, life: 3000 });
            }

        }).catch(error => {
            this.setState({ isLoading: false })

        })
    }


    onHandleConcessionClose = () => {
        this.setState({
            openConcessionDialog: false,
            raiseData: [],
            studentInfo: {}
        })
    }
    onHandleRefund = (data) => {
        this.setState({
            openeRefundDialog: true,
            studentInfo: data
        }, () => { this.getFeeTypesData() })
    }
    onHandleRefundClose = (data) => {
        this.setState({
            openeRefundDialog: false,
            refundRemarks: '',
            showParentDetailsDialog: false,
            paymentType: '',
            transactionDate: null,
            chequeIssuedTo: '',
            chequeNo: '',
            chequeDate: null,
            bankName: '',
            bankBranchName: '',
            transactionId: '',
            approvalCode: '',
            cardNo: '',
            userBankName: '',
            rrNumber: ''
        })
    }

    handleSetSearchValue = (value) => {
        this.setState({
            searchValue: value,
            dropdownsData: {
                boardId: '',
                branchId: "",
                classId: '',
                sectionId: '',
            }
        }, () => {
            this.debouncedApiCall()

        })
    }
    handleSearchLevel = (value) => {

        this.setState({ searchLevel: value, studentId: "", searchValue: "", studentsData: [] })
    }

    onStudentChange = (e) => {
        this.setState({ studentId: e.value }, () => {
            this.getStudentData()
        })

    }


    handleTermWisePercentageValue = (e, rowData) => {
        let concessionAmt = Number(e.target.value)
        if (rowData.dueAmount > 0) {
            if (rowData?.dueAmount >= concessionAmt) {
                const updatedData = this.state.raiseData.map(item => {
                    if (item._id === rowData._id) {
                        return { ...item, currentConAmt: concessionAmt };
                    }
                    return item;
                });
                this.setState({ raiseData: updatedData });
            }

        }
    };

    handleFeeTypeRefund = (e, rowData) => {

        let refundAmount = Number(e.target.value)
        if (rowData.amountPaid > 0 && rowData.amountPaid >= refundAmount) {

            const updatedData = this.state.RefundfeeData?.map(item => {
                if (item._id === rowData._id) {
                    return { ...item, refundAmt: refundAmount };
                }
                return item;
            });
            this.setState({ RefundfeeData: updatedData });
        } else if (refundAmount === 0 || e.target.value === '') {
            // Allow clearing the value
            const updatedData = this.state.RefundfeeData?.map(item => {
                if (item._id === rowData._id) {
                    return { ...item, refundAmt: refundAmount };
                }
                return item;
            });
            this.setState({ RefundfeeData: updatedData });
        }
    }


    handleConcessionType = (e, rowData) => {

        const updatedData = this.state.raiseData.map(item => {
            if (item._id === rowData._id) {
                return { ...item, concessionType: e.target.value };
            }
            return item;
        });
        this.setState({ raiseData: updatedData });
    }


    handleSetSearchTypeValue = (value) => {

        this.setState({ searchType: value }, () => {
            if (this.state.searchType == "studentName") {
                this.setState({ isUserNameSearch: true, })
            } else {
                this.setState({ isUserEnrollSearch: true, })
            }

        })
    }

    onHandleRaiseConcession = () => {
        this.setState({
            isLoading: true
        })
        const { studentInfo } = this.state


        let payload = {
            user_id: studentInfo?.user_id,
            academicYear: studentInfo?.user_info?.academicYear,
            branchId: studentInfo?.user_info?.branchId,
            boardId: studentInfo?.user_info?.boardId,
            gradeId: studentInfo?.user_info?.classId,
            sectionId: studentInfo?.user_info?.sectionId,
            enrollmentId: studentInfo?.enrollmentId,
            username: studentInfo?.user_info?.username,
            sectionName: studentInfo?.user_info?.sectionName,
            branchName: studentInfo?.user_info?.branchName,
            boardName: studentInfo?.user_info?.["custom:board"],
            gradeName: studentInfo?.user_info?.["custom:grade"],
            contactPersonName: studentInfo?.user_info?.contactPersonName,
            parentContactNo: studentInfo?.user_info?.parentContactNo,
            firstName: studentInfo?.user_info?.firstName,
            lastName: studentInfo?.user_info?.lastName,
            isClosed: false,
            concessionsRaised: []
        }
        this.state?.raiseData?.filter((el) => {
            if (el?.currentConAmt || el?.concessionType) {
                el.isClosed = false
                payload?.concessionsRaised.push(el)
            }
        })
        let flag = payload?.concessionsRaised?.every((each) => {
            if (each.currentConAmt !== undefined && each.currentConAmt !== "" && each.concessionType !== undefined && each.concessionType !== "") {
                return true
            } else {
                return false
            }
        })

        let url = `${baseUrlAdmin}/concession/addConcession`;
        if (payload?.concessionsRaised?.length && flag) {
            this.service.post(url, payload, true).then(data => {
                if (data.status && data.res.status) {

                    this.setState({
                        isLoading: false,
                        openConcessionDialog: false,
                        raiseData: [],

                    })
                    this.toast?.show({ severity: 'success', summary: 'Success', detail: data.res.message, life: 3000 });
                    this.getStudentData()
                } else {
                    this.setState({
                        isLoading: false
                    })
                    this.toast?.show({ severity: 'error', summary: 'Error', detail: data.errMessage, life: 3000 });

                }
            });
        } else {
            this.setState({
                isLoading: false
            })
            this.toast?.show({ severity: 'error', summary: 'Please Enter All the required Concession Type and TermWise Value Fields', detail: 'Validation failed' });
        }

    }
    onHandleRaiseRefund = () => {
        const { studentInfo } = this.state
        let refundFeeData = this.state.RefundfeeData
        let url = `${baseUrlAdmin}/fee-refund/add-refund`;
        let academicYear = localStorage.getItem('userAcademicYear')
        let key = "refundAmt"
        // const filteredArray = refundFeeData.filter(obj => obj.hasOwnProperty(key));
        const filteredArray = refundFeeData.filter(obj => obj.hasOwnProperty(key) && obj[key] > 0);


        // Validate payment mode selection
        if (!this.state.paymentType) {
            this.toast?.show({
                severity: 'error',
                summary: 'Payment Mode Required',
                detail: 'Please select a payment mode',
                life: 3000
            });
            return;
        }

        // Payment mode specific validations
        let validationFlag = true;
        let validationMessage = '';

        // Online payment validation
        if (this.state.paymentType === '1b1a76b4-c538-4968-a20b-0e5a3b4a1c54') {
            if (!this.state.bankAccountHolderName || this.state.bankAccountHolderName.trim() === '') {
                validationFlag = false;
                validationMessage = 'Bank Account Holder Name is required for online payments';
            } else if (!this.state.accountNumber || this.state.accountNumber.trim() === '') {
                validationFlag = false;
                validationMessage = 'Account Number is required for online payments';
            } else if (!this.state.ifscCode || this.state.ifscCode.trim() === '') {
                validationFlag = false;
                validationMessage = 'IFSC Code is required for online payments';
            } else if (!this.state.bankNameAndBranch || this.state.bankNameAndBranch.trim() === '') {
                validationFlag = false;
                validationMessage = 'Bank Name & Branch is required for online payments';
            }
        }

        // QR Code payment validation
        if (this.state.paymentType === '32b180cf-7727-46ef-b2a8-e7b1b19fd489') {
            if (!this.state.upiId || this.state.upiId.trim() === '') {
                validationFlag = false;
                validationMessage = 'UPI ID is required for QR Code payments';
            }
        }

        // Cheque payment validation
        if (this.state.paymentType === '1c98862e-46dc-4454-a120-7d15e2e56e2f') {
            if (!this.state.chequeIssuedTo || this.state.chequeIssuedTo.trim() === '') {
                validationFlag = false;
                validationMessage = 'Cheque Issued To is required for cheque payments';
            } else if (!this.state.chequeNo || this.state.chequeNo.trim() === '') {
                validationFlag = false;
                validationMessage = 'Cheque Number is required for cheque payments';
            } else if (!this.state.chequeDate) {
                validationFlag = false;
                validationMessage = 'Cheque Date is required for cheque payments';
            } else if (!this.state.bankName || this.state.bankName.trim() === '') {
                validationFlag = false;
                validationMessage = 'Bank Name is required for cheque payments';
            } else if (!this.state.bankBranchName || this.state.bankBranchName.trim() === '') {
                validationFlag = false;
                validationMessage = 'Bank Branch Name is required for cheque payments';
            }
        }

        // DD (Demand Draft) payment validation
        if (this.state.paymentType === '9d08ebab-2d3e-4a30-8460-4e4092fe30a1') {
            if (!this.state.chequeIssuedTo || this.state.chequeIssuedTo.trim() === '') {
                validationFlag = false;
                validationMessage = 'DD Issued To is required for DD payments';
            } else if (!this.state.chequeNo || this.state.chequeNo.trim() === '') {
                validationFlag = false;
                validationMessage = 'DD Number is required for DD payments';
            } else if (!this.state.chequeDate) {
                validationFlag = false;
                validationMessage = 'DD Date is required for DD payments';
            } else if (!this.state.bankName || this.state.bankName.trim() === '') {
                validationFlag = false;
                validationMessage = 'Bank Name is required for DD payments';
            } else if (!this.state.bankBranchName || this.state.bankBranchName.trim() === '') {
                validationFlag = false;
                validationMessage = 'Bank Branch Name is required for DD payments';
            }
        }

        // Show validation error if any required field is missing
        if (!validationFlag) {
            this.toast?.show({
                severity: 'error',
                summary: 'Payment Details Required',
                detail: validationMessage,
                life: 3000
            });
            return;
        }

        let payload = {
            user_id: studentInfo?.user_id,
            academicYear: studentInfo?.user_info?.academicYear,
            branchId: studentInfo?.user_info?.branchId,
            boardId: studentInfo?.user_info?.boardId,
            gradeId: studentInfo?.user_info?.classId,
            sectionId: studentInfo?.user_info?.sectionId,
            enrollmentId: studentInfo?.enrollmentId,
            username: studentInfo?.user_info?.username,
            sectionName: studentInfo?.user_info?.sectionName,
            branchName: studentInfo?.user_info?.branchName,
            boardName: studentInfo?.user_info?.["custom:board"],
            gradeName: studentInfo?.user_info?.["custom:grade"],
            contactPersonName: studentInfo?.user_info?.contactPersonName,
            parentContactNo: studentInfo?.user_info?.parentContactNo,
            firstName: studentInfo?.user_info?.firstName,
            lastName: studentInfo?.user_info?.lastName,
            isClosed: false,
            refundFeeTypesData: filteredArray,
            refundRemarks: this.state.refundRemarks,
            paymentType: this.state.paymentType,
            // New fields for Online payment
            bankAccountHolderName: this.state.bankAccountHolderName,
            accountNumber: this.state.accountNumber,
            ifscCode: this.state.ifscCode,
            bankNameAndBranch: this.state.bankNameAndBranch,
            // New field for QR Code payment
            upiId: this.state.upiId,
            // Existing fields for Cheque/DD
            chequeIssuedTo: this.state.chequeIssuedTo,
            chequeNo: this.state.chequeNo,
            chequeDate: this.state.chequeDate,
            bankName: this.state.bankName,
            bankBranchName: this.state.bankBranchName
        }

        if (payload && filteredArray.length) {
            this.setState({ isLoading: true });
            this.service.post(url, payload, true).then(data => {
                this.setState({ isLoading: false });
                if (data.status && data.res.status) {
                    this.setState({
                        openeRefundDialog: false,
                        showParentDetailsDialog: false,
                        RefundfeeData: [],
                        refundRemarks: '',
                        paymentType: '',
                        chequeIssuedTo: '',
                        chequeNo: '',
                        chequeDate: null,
                        bankName: '',
                        bankBranchName: '',
                        // Reset new fields
                        bankAccountHolderName: '',
                        accountNumber: '',
                        ifscCode: '',
                        bankNameAndBranch: '',
                        upiId: '',
                        remarks: ''
                    })
                    this.toast?.show({ severity: 'info', summary: 'Success', detail: data.res.message, life: 3000 });
                    this.getStudentData()
                } else {
                    this.toast?.show({ severity: 'error', summary: 'Error', detail: data.errMessage, life: 3000 });

                }
            }).catch(error => {
                this.setState({ isLoading: false });
                this.toast?.show({ severity: 'error', summary: 'Error', detail: 'Failed to process refund', life: 3000 });
            });
        } else {
            this.toast?.show({ severity: 'error', summary: 'Please Enter All the required Fields', detail: 'Validation failed' });

        }
    }

    onHandleNext = () => {
        // Validate if there are refund amounts entered
        const { RefundfeeData } = this.state;
        const filteredArray = RefundfeeData.filter(obj => obj.hasOwnProperty('refundAmt'));

        if (filteredArray.length === 0) {
            this.toast?.show({
                severity: 'error',
                summary: 'Please Enter Refund Amounts',
                detail: 'At least one refund amount must be entered',
                life: 3000
            });
            return;
        }

        this.setState({
            showParentDetailsDialog: true,
            openeRefundDialog: false
        });
    }

    onHandleParentDetailsClose = () => {
        this.setState({
            showParentDetailsDialog: false,
            openeRefundDialog: true,
            paymentType: '',
            chequeIssuedTo: '',
            chequeNo: '',
            chequeDate: null,
            bankName: '',
            bankBranchName: '',
            // Reset new fields
            bankAccountHolderName: '',
            accountNumber: '',
            ifscCode: '',
            bankNameAndBranch: '',
            upiId: ''
        });
    }

    onPage = (event) => {
        this.setState({ lazyParams: event }, this.getStudentData);
    }

    render() {
        console.log(this.state.RefundfeeData, "RefundfeeData")
        return (
            <div className="ma-main">

                <div className=" datatable-crud-demo ma-m30 mx-2 mb-5">


                    <div className="flex">
                        <div className="flex flex-column justify-content-center align-items-center mt-3">
                            <RadioButton inputId="ingredient1" onChange={(e) => this.handleSearchLevel(1)} checked={this.state.searchLevel === 1} />
                        </div>

                        <div>
                            <BranchToSectionDD selectedValue={this.state.searchLevel} setValues={this.setDropdownValues} />
                        </div>
                    </div>

                    <div className="col-12 ml-5">
                        <label className='label'>Student<span className='ma-required'>*</span></label>
                        <div className='mt-2'>
                            <ClassetDropdown
                                // icon={<MailIcon />}
                                id='student'
                                className=""
                                height="48px"
                                width="327px"
                                options={this.state?.students}
                                value={this.state.studentId}
                                disabled={this.state?.searchLevel === 2}
                                onChange={this.onStudentChange}
                                placeholder={(
                                    <div>
                                        <span className=''>Select Student</span>
                                    </div>
                                )}
                            />

                        </div>
                    </div>

                    <div className="flex mt-4">
                        <div className="flex flex-column justify-content-center align-items-center mt-3">
                            <RadioButton inputId="ingredient2" onChange={(e) => this.handleSearchLevel(2)} checked={this.state.searchLevel === 2} />
                        </div>

                        <div className="field ml-4">

                            <ClassetStudentSearchFilter
                                ref={this.studentSearchRef}
                                selectedValue={this.state.searchLevel}
                                setValues={this.setDropdownValues}
                                singleSelectInput={true}
                            />
                        </div>
                    </div>

                </div>

                <DataTable ref={(el) => this.dt = el}
                    value={this.state.studentsData}
                    dataKey="id"
                    paginator
                    lazy
                    responsiveLayout="scroll"
                    className="dataTableValuesText"
                    showGridlines
                    selectionMode={'checkbox'}
                    columnResizeMode="expand"
                    resizableColumns
                    onPage={this.onPage}
                    first={this.state.lazyParams.first}
                    last={this.state.totalRecords}
                    rows={this.state.lazyParams.rows}
                    totalRecords={this.state.totalRecords}
                    rowsPerPageOptions={[5, 10, 25, 50, 100]}
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                    globalFilter={this.state.globalFilter}
                >

                    <Column filterField="studentName" field="user_info.given_name" sortable bodyClassName='text-center' header="Student Name" alignHeader={"center"} />
                    <Column filterField="enrollmentNo" field="user_info.username" sortable bodyClassName='text-center' header="Enrollment No" alignHeader={"center"} body={(rowData) => rowData?.user_info?.username ? rowData?.user_info?.username.slice(3) : ''} />
                    <Column filterField="grade" sortable bodyClassName='text-center' header="Grade-Section" alignHeader={"center"} body={(rowData, { rowIndex }) => {
                        return (

                            <p>{rowData ? `${rowData?.user_info?.["custom:grade"]} - ${rowData?.user_info?.["sectionName"]}` : null}</p>
                        )
                    }} />
                    <Column sortable bodyClassName='text-center' header="Refund" alignHeader={"center"} body={(rowData, { rowIndex }) => {
                        return (
                            <div className='custom-fee-pay text-center'>
                                <Button className='text-center' style={{ backgroundColor: '#076EFF', border: '1px solid #076EFF' }} onClick={() => this.onHandleRefund(rowData)}>
                                    <p className='payButton pl-2' style={{ color: rowData.totalDue !== 0 ? "#ffffff" : "#C6CED2" }}>Refund</p>
                                </Button>
                            </div>



                        )
                    }} />

                </DataTable>





                <Dialog
                    isopen={this.state.openeRefundDialog}
                    visible={this.state.openeRefundDialog}
                    className="w-11"
                    draggable={false}
                    onHide={this.onHandleRefundClose}
                    closable={false}
                    header={() => {
                        return (<div className='mt-2 mb-4'>
                            <h3 className="formhead text-center ">Refund Fee</h3>

                        </div>)
                    }}
                    footer={() => (
                        <div className='flex justify-content-center  align-items-center mb-4'>
                        </div>
                    )}

                >

                    <>
                        <div className='grid m-2'>
                            <div className="col-4 " >
                                <label className='ma-label-s2 font-serif font-semibold text-900 text-lg'>Student Name</label>
                                <div className="mt-2">
                                    <ClassetInputText
                                        id='studentName'
                                        // icon={<MailIcon />}
                                        className=""
                                        height="48px"
                                        width="368px"
                                        value={this.state.studentInfo?.user_info?.given_name}
                                        disabled={true}
                                    />
                                </div>
                            </div>
                            <div className="col-4 " >
                                <label className='ma-label-s2 font-serif font-semibold text-900 text-lg'>Enrollment No</label>
                                <div className="mt-2">
                                    <ClassetInputText
                                        id='enrollmentNo'
                                        // icon={<MailIcon />}
                                        height="48px"
                                        width="368px"
                                        value={this.state.studentInfo?.user_info?.username.slice(3)}
                                        disabled={true}
                                    />
                                </div>
                            </div>
                            <div className="col-4" >
                                <label className='ma-label-s2 font-serif font-semibold text-900 text-lg'>Grade</label>
                                <div className="mt-2">
                                    <ClassetInputText
                                        id='grade'
                                        // icon={<MailIcon />}
                                        height="48px"
                                        width="368px"
                                        value={this.state.studentInfo?.user_info?.['custom:grade']}
                                        disabled={true}
                                    />
                                </div>
                            </div>
                            <div className="col-4" >
                                <label className='ma-label-s2 font-serif font-semibold text-900 text-lg'>Section</label>
                                <div className="mt-2">
                                    <ClassetInputText
                                        id='section'
                                        // icon={<MailIcon />}
                                        height="48px"
                                        width="368px"
                                        value={this.state.studentInfo?.user_info?.sectionName}
                                        disabled={true}
                                    />
                                </div>
                            </div>
                            <div className="col-4" >
                                <label className='ma-label-s2 font-serif font-semibold text-900 text-lg'>Board</label>
                                <div className="mt-2">
                                    <ClassetInputText
                                        id='board'
                                        // icon={<MailIcon />}
                                        height="48px"
                                        width="368px"
                                        value={this.state.studentInfo?.user_info?.['custom:board']}
                                        disabled={true}
                                    />
                                </div>
                            </div>
                            <div className="col-4 mt-4" >
                                <p className='ma-label-s2 font-serif concession-amt'>Total Refund Raised: <span className='underline' style={{ color: "green" }}>{this.state.totalRefundAmt || 0}</span></p>
                            </div>

                        </div>

                        <DataTable ref={(el) => this.dt = el}
                            value={this.state?.RefundfeeData}
                            dataKey="id"
                            paginator
                            rows={10}
                            rowsPerPageOptions={[5, 10, 25, 50, 100]}
                            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                            currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                            globalFilter={this.state.globalFilter}
                        >

                            <Column filterField="refundableFeeType" field="feeType" sortable bodyClassName='text-center' header="Refundable Fee Type" alignHeader={"center"} />
                            <Column filterField="amountPaid" field="amountPaid" sortable bodyClassName='text-center' header="Paid Fee" alignHeader={"center"} 
                            
                            />
                            <Column bodyClassName='text-center' header="Refundable Amount" alignHeader={"center"} body={(rowData, index) => {
                                return (
                                    <div className='flex justify-content-center'>
                                        <ClassetInputText
                                            className="text-xl"
                                            type="text"
                                            height="48px"
                                            width="216px"
                                            placeholder={!(rowData?.refundAmt) ? 'Enter Value' : ''}
                                            value={rowData?.amountPaid > 0 ? rowData?.refundAmt || '' : rowData?.refundAmt || 0}
                                            step="0.01"
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                if (value.match(/^\d*\.?\d{0,2}$/)) {
                                                    this.handleFeeTypeRefund(e, rowData);
                                                }
                                            }}
                                            onWheel={(e) => e.target.blur()}
                                            list=""
                                            autoComplete="off"

                                            // keyfilter="text"
                                            disabled={rowData?.amountPaid > 0 ? false : true}
                                        />
                                    </div>
                                )
                            }} />
                            <Column filterField="refundAmount" field="termWisePercentageOrValue" sortable bodyClassName='text-center' header="Refund Amount" alignHeader={"center"} body={(rowData, index) => {
                                return (<p>{rowData?.refundAmt || 0}</p>
                                )
                            }} />
                            <Column filterField="totalDue" field="totalDue" sortable bodyClassName='text-center' header="Total Due" alignHeader={"center"} body={(rowData, index) => {
                                const totalDueAfterConcession = rowData?.totalDue - rowData?.concession || 0;
                                const refundAmount = rowData?.refundAmt || 0;
                                const updatedTotalDue = totalDueAfterConcession + refundAmount;
                                return (
                                    <p>{Math.round(updatedTotalDue * 100) / 100}</p>
                                );
                            }} />

                        </DataTable>

                        <div className='mt-4'>
                            <ClassetTextArea
                                width={'60%'}
                                style={{ height: '100px' }}
                                label={'Refund Remarks:'}
                                placeholder="Enter remarks for the refund..."
                                value={this.state.refundRemarks}
                                onChange={(e) => this.setState({ refundRemarks: e.target.value })}
                            />
                        </div>

                        <div className='flex justify-content-center  align-items-center mt-4'>
                            <Button label='Next' className='submitButtonn mr-4 button text-lg ' onClick={this.onHandleNext} />
                            <Button className='cancelButtonn '
                                onClick={this.onHandleRefundClose} >
                                <p className='cancelButtonnText'>Cancel</p>
                            </Button>
                        </div>

                    </>
                </Dialog>

                {/* Parent Details Dialog */}
                <Dialog
                    visible={this.state.showParentDetailsDialog}

                    style={{ width: "400px", height: '80vh', minHeight: '600px' }}
                    draggable={false}
                    onHide={this.onHandleParentDetailsClose}
                    closable={false}
                    header={() => {
                        return (<div className='mt-2 mb-4'>
                            <h3 className="formhead text-center ">Payment Details</h3>
                        </div>)
                    }}
                >
                    <div style={{ height: 'calc(100% - 0px)', display: 'flex', flexDirection: 'column', position: 'relative' }}>
                        <div className="flex flex-column align-items-center flex-1" style={{ overflowY: 'auto', }}>
                            <div className="w-full flex justify-content-center mt-3">
                                <div style={{ width: '300px' }}>
                                    <label className="label mb-2">
                                        Payment Mode<span className="ma-required">*</span>
                                    </label>
                                    <div className="mt-2">
                                        <ClassetDropdown
                                            id="paymentType"
                                            className=""
                                            height="48px"
                                            width="100%"
                                            options={paymentModes?.filter(el => 
                                                el.label !== "Adjustment" && 
                                                el.label !== "Credit Card" && 
                                                el.label !== "Debit Card"
                                            )}
                                            value={this.state.paymentType}
                                            onChange={(e) => this.setState({ paymentType: e.value })}
                                            placeholder={
                                                <div>
                                                    <span className="">Select Payment Mode</span>
                                                </div>
                                            }
                                        />
                                    </div>
                                </div>
                            </div>

                            {/* Cash - no additional fields needed */}

                            {/* Online fields - New structure */}
                            {this.state.paymentType === '1b1a76b4-c538-4968-a20b-0e5a3b4a1c54' && (
                                <>
                                    <div className="w-full flex justify-content-center mt-3">
                                        <div style={{ width: '300px' }}>
                                            <label className="label mb-2">
                                                Bank Account Holder Name<span className="ma-required">*</span>
                                            </label>
                                            <div className="mt-2">
                                                <ClassetInputText
                                                    id="bankAccountHolderName"
                                                    height="48px"
                                                    width="100%"
                                                    placeholder="Enter Bank Account Holder Name"
                                                    value={this.state.bankAccountHolderName}
                                                    onChange={(e) => this.setState({ bankAccountHolderName: e.target.value })}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="w-full flex justify-content-center mt-3">
                                        <div style={{ width: '300px' }}>
                                            <label className="label mb-2">
                                                Account Number<span className="ma-required">*</span>
                                            </label>
                                            <div className="mt-2">
                                                <ClassetInputText
                                                    id="accountNumber"
                                                    height="48px"
                                                    width="100%"
                                                    placeholder="Enter Account Number"
                                                    value={this.state.accountNumber}
                                                    onChange={(e) => this.setState({ accountNumber: e.target.value })}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="w-full flex justify-content-center mt-3">
                                        <div style={{ width: '300px' }}>
                                            <label className="label mb-2">
                                                IFSC Code<span className="ma-required">*</span>
                                            </label>
                                            <div className="mt-2">
                                                <ClassetInputText
                                                    id="ifscCode"
                                                    height="48px"
                                                    width="100%"
                                                    placeholder="Enter IFSC Code"
                                                    value={this.state.ifscCode}
                                                    onChange={(e) => this.setState({ ifscCode: e.target.value })}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="w-full flex justify-content-center mt-3">
                                        <div style={{ width: '300px' }}>
                                            <label className="label mb-2">
                                                Bank Name & Branch<span className="ma-required">*</span>
                                            </label>
                                            <div className="mt-2">
                                                <ClassetInputText
                                                    id="bankNameAndBranch"
                                                    height="48px"
                                                    width="100%"
                                                    placeholder="Enter Bank Name & Branch"
                                                    value={this.state.bankNameAndBranch}
                                                    onChange={(e) => this.setState({ bankNameAndBranch: e.target.value })}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </>
                            )}

                            {/* QR Code fields */}
                            {this.state.paymentType === '32b180cf-7727-46ef-b2a8-e7b1b19fd489' && (
                                <div className="w-full flex justify-content-center mt-3">
                                    <div style={{ width: '300px' }}>
                                        <label className="label mb-2">
                                            UPI ID<span className="ma-required">*</span>
                                        </label>
                                        <div className="mt-2">
                                            <ClassetInputText
                                                id="upiId"
                                                height="48px"
                                                width="100%"
                                                placeholder="Enter UPI ID"
                                                value={this.state.upiId}
                                                onChange={(e) => this.setState({ upiId: e.target.value })}
                                            />
                                        </div>
                                    </div>
                                </div>
                            )}

                            {/* Cheque fields */}
                            {this.state.paymentType === '1c98862e-46dc-4454-a120-7d15e2e56e2f' && (
                                <>
                                    <div className="w-full flex justify-content-center mt-3">
                                        <div style={{ width: '300px' }}>
                                            <label className="label mb-2">
                                                Cheque Issued To
                                            </label>
                                            <div className="mt-2">
                                                <ClassetInputText
                                                    id="chequeIssuedTo"
                                                    height="48px"
                                                    width="100%"
                                                    placeholder="Enter Cheque Issued To"
                                                    value={this.state.chequeIssuedTo}
                                                    onChange={(e) => this.setState({ chequeIssuedTo: e.target.value })}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="w-full flex justify-content-center mt-3">
                                        <div style={{ width: '300px' }}>
                                            <label className="label mb-2">
                                                Cheque Number
                                            </label>
                                            <div className="mt-2">
                                                <ClassetInputText
                                                    id="chequeNo"
                                                    height="48px"
                                                    width="100%"
                                                    placeholder="Enter Cheque Number"
                                                    value={this.state.chequeNo}
                                                    onChange={(e) => this.setState({ chequeNo: e.target.value })}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="w-full flex justify-content-center mt-3">
                                        <div style={{ width: '300px' }}>
                                            <label className="label mb-2">
                                                Cheque Date
                                            </label>
                                            <div className="mt-2">
                                                <ClassetCalendar
                                                    className=""
                                                    height="48px"
                                                    width="100%"
                                                    placeholder="Select Cheque Date"
                                                    calendarMode="single"
                                                    value={this.state.chequeDate}
                                                    onChange={(e) => this.setState({ chequeDate: e.value })}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="w-full flex justify-content-center mt-3">
                                        <div style={{ width: '300px' }}>
                                            <label className="label mb-2">
                                                Bank Name
                                            </label>
                                            <div className="mt-2">
                                                <ClassetInputText
                                                    id="bankName"
                                                    height="48px"
                                                    width="100%"
                                                    placeholder="Enter Bank Name"
                                                    value={this.state.bankName}
                                                    onChange={(e) => this.setState({ bankName: e.target.value })}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="w-full flex justify-content-center mt-3">
                                        <div style={{ width: '300px' }}>
                                            <label className="label mb-2">
                                                Bank Branch Name
                                            </label>
                                            <div className="mt-2">
                                                <ClassetInputText
                                                    id="bankBranchName"
                                                    height="48px"
                                                    width="100%"
                                                    placeholder="Enter Bank Branch Name"
                                                    value={this.state.bankBranchName}
                                                    onChange={(e) => this.setState({ bankBranchName: e.target.value })}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </>
                            )}

                            {/* DD fields */}
                            {this.state.paymentType === '9d08ebab-2d3e-4a30-8460-4e4092fe30a1' && (
                                <>
                                    <div className="w-full flex justify-content-center mt-3">
                                        <div style={{ width: '300px' }}>
                                            <label className="label mb-2">
                                                DD Issued To
                                            </label>
                                            <div className="mt-2">
                                                <ClassetInputText
                                                    id="chequeIssuedTo"
                                                    height="48px"
                                                    width="100%"
                                                    placeholder="Enter DD Issued To"
                                                    value={this.state.chequeIssuedTo}
                                                    onChange={(e) => this.setState({ chequeIssuedTo: e.target.value })}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="w-full flex justify-content-center mt-3">
                                        <div style={{ width: '300px' }}>
                                            <label className="label mb-2">
                                                DD Number
                                            </label>
                                            <div className="mt-2">
                                                <ClassetInputText
                                                    id="chequeNo"
                                                    height="48px"
                                                    width="100%"
                                                    placeholder="Enter DD Number"
                                                    value={this.state.chequeNo}
                                                    onChange={(e) => this.setState({ chequeNo: e.target.value })}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="w-full flex justify-content-center mt-3">
                                        <div style={{ width: '300px' }}>
                                            <label className="label mb-2">
                                                DD Date
                                            </label>
                                            <div className="mt-2">
                                                <ClassetCalendar
                                                    className=""
                                                    height="48px"
                                                    width="100%"
                                                    placeholder="Select DD Date"
                                                    calendarMode="single"
                                                    value={this.state.chequeDate}
                                                    onChange={(e) => this.setState({ chequeDate: e.value })}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="w-full flex justify-content-center mt-3">
                                        <div style={{ width: '300px' }}>
                                            <label className="label mb-2">
                                                Bank Name
                                            </label>
                                            <div className="mt-2">
                                                <ClassetInputText
                                                    id="bankName"
                                                    height="48px"
                                                    width="100%"
                                                    placeholder="Enter Bank Name"
                                                    value={this.state.bankName}
                                                    onChange={(e) => this.setState({ bankName: e.target.value })}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12 w-full flex justify-content-center mt-3">
                                        <div style={{ width: '300px' }}>
                                            <label className="label mb-2">
                                                Bank Branch Name
                                            </label>
                                            <div className="mt-2">
                                                <ClassetInputText
                                                    id="bankBranchName"
                                                    height="48px"
                                                    width="100%"
                                                    placeholder="Enter Bank Branch Name"
                                                    value={this.state.bankBranchName}
                                                    onChange={(e) => this.setState({ bankBranchName: e.target.value })}
                                                />
                                            </div>
                                        </div>
                                    </div>


                                </>
                            )}

                            <div className="col-11">
                                <label className="label mb-2 ">
                                    Remarks
                                </label>
                                <div className="mt-2">
                                    <ClassetTextArea
                                        id="feeType"
                                        className=""
                                        height="48px"
                                        width="368px"
                                        placeholder="Enter Remarks"
                                        value={this.state.remarks}
                                        onChange={(e) => this.setState({ remarks: e.target.value })}
                                    />
                                </div>
                            </div>

                        </div>

                        {/* Fixed buttons at bottom */}
                        <div style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            gap: '15px'
                        }}>
                            <Button label='Raise Refund' className='submitButtonn button text-lg' style={{ width: "150px" }} onClick={this.onHandleRaiseRefund} />
                            <Button style={{ width: "150px" }} className='cancelButtonn' onClick={this.onHandleParentDetailsClose}>
                                <p className='cancelButtonnText'>Cancel</p>
                            </Button>
                        </div>
                    </div>
                </Dialog>

                <Toast ref={(el) => this.toast = el} position="bottom-right" />
                {this.state.isLoading && <LoadingComponent />}
            </div>
        )
    }
}

export default FeeRefund